export default __webpack_public_path__ + "static/media/changepasswordbackground.5b312bf1.jpg";